import {
    DialogProvider as AriakitDialogProvider,
    DialogDisclosure as AriakitDialogDisclosure,
    DialogProps,
    DialogDismiss as AriakitDialogDismiss,
    DialogDismissProps
} from '@ariakit/react'
import {
    StyledDialog,
    StyledDialogDescription,
    StyledDialogHeader,
    StyledDialogHeading,
    StyledDialogBody,
    StyledDialogFooter
} from './style'
import {Overlay} from '../overlay/Overlay'
import {XCloseIcon} from '../icon/Icon'
import {Button} from '../button/Button'
import {CSSProperties, HTMLAttributes} from 'react'

export const DialogProvider = AriakitDialogProvider
export const DialogDisclosure = AriakitDialogDisclosure
export const Dialog = ({
    width,
    height,
    overflowY,
    ...rest
}: DialogProps & {
    width?: CSSProperties['width']
    height?: CSSProperties['height']
    overflowY?: CSSProperties['overflowY']
}) => (
    <StyledDialog
        backdrop={<Overlay />}
        unmountOnHide
        portal
        $width={width}
        $height={height}
        $overflowY={overflowY}
        {...rest}
    />
)
export const DialogDismiss = (props: DialogDismissProps) => (
    <AriakitDialogDismiss
        render={
            <Button variant="ghost" size="sm" shape="square">
                <XCloseIcon />
            </Button>
        }
        {...props}
    />
)
export const DialogHeading = StyledDialogHeading
export const DialogDescription = StyledDialogDescription
export const DialogHeader = StyledDialogHeader
export const DialogBody = ({gap = 6, ...rest}: HTMLAttributes<HTMLDivElement> & {gap?: number}) => (
    <StyledDialogBody $gap={gap} {...rest} />
)
export const DialogFooter = StyledDialogFooter
